import { IFormValues } from 'components';

export const DEFAULT_VALUES: IFormValues = {
  // общее
  code: '',
  title: '',
  amount: '',
  rewardType: null,
  rewardValue: '',

  // период
  active: false,
  activeFrom: null,
  activeTo: null,
  is_tracked: false,

  // настройки генерации (для кампаний)
  codesCount: '',
  codeLength: null,
  prefix: '',
  format: null,

  // область действия
  scopes: [],
};
